import { jwtDecode } from 'jwt-decode';
import { registerOnUnauthorized } from '../config/axios'; // not needed; see below

let expiryTimer = null;
let onExpire = null;

/**
 * Shared-side hook: app registers what to do when a token expires.
 * In mobile, you can pass the same function you use for onUnauthorized.
 */
export function registerOnSessionExpired(fn) {
  onExpire = typeof fn === 'function' ? fn : null;
}

export function clearSessionExpiryTimer() {
  if (expiryTimer) {
    clearTimeout(expiryTimer);
    expiryTimer = null;
  }
}

export function scheduleSessionExpiryTimer(token) {
  clearSessionExpiryTimer();

  if (!token) return;

  let expMs = null;
  try {
    const { exp } = jwtDecode(token);
    if (typeof exp === 'number') expMs = exp * 1000;
  } catch {
    expMs = null;
  }

  if (!expMs) return;

  // log out a bit early to avoid edge races
  const skewMs = 10_000;
  const delay = expMs - Date.now() - skewMs;

  if (delay <= 0) {
    if (onExpire) onExpire('Session expired');
    return;
  }

  expiryTimer = setTimeout(() => {
    if (onExpire) onExpire('Session expired');
  }, delay);
}
